export default "__VITE_ASSET__aUDAXorr__"